export const WORKER_POSITIONS = [
  "WAITER",
  "FOOD_RUNNER",
  "HOST",
  "BARTENDER",
  "BAR_BACK",
  "BARISTA",
  "BEVERAGE",
  "HEAD_CHEF",
  "KITCHEN_SUPERVISOR",
  "HOT_KITCHEN",
  "HOT_KITCHEN_HELPER",
  "COLD_KITCHEN",
  "COLD_KITCHEN_HELPER",
  "COOK",
  "KITCHEN_STAFF",
  "KITCHEN_HELPER",
  "BAKER",
  "DISHWASHER",
  "CASHIER",
  "RECEPTIONIST",
  "DELIVERY",
  "SECURITY",
  "PARKING",
  "CLEANER",
  "STOCK_KEEPER",
  "MANAGER",
  "SHIFT_LEADER",
  "SUPERVISOR",
  "TRAINER",
  "MARKETING",
  // `OTHER` is retained for backward compatibility with existing rows but is no
  // longer offered in the posting form (see position-groups.ts).
  "OTHER",
] as const;

export type WorkerPosition = (typeof WORKER_POSITIONS)[number];

export const WORKER_POSITION_LABEL_VI: Record<WorkerPosition, string> = {
  WAITER: "Phục vụ",
  FOOD_RUNNER: "Chạy bàn / Tiếp thực",
  HOST: "Đón khách (Host)",
  BARTENDER: "Pha chế (Bar)",
  BAR_BACK: "Phụ bar",
  BARISTA: "Pha chế (Café)",
  BEVERAGE: "Pha chế (Trà sữa, sinh tố)",
  HEAD_CHEF: "Bếp chính",
  KITCHEN_SUPERVISOR: "Giám sát bếp",
  HOT_KITCHEN: "Bếp nóng",
  HOT_KITCHEN_HELPER: "Phụ bếp nóng",
  COLD_KITCHEN: "Bếp lạnh",
  COLD_KITCHEN_HELPER: "Phụ bếp lạnh",
  COOK: "Bếp phụ",
  KITCHEN_STAFF: "Nhân viên Bếp",
  KITCHEN_HELPER: "Phụ bếp / Tạp vụ bếp",
  BAKER: "Thợ làm bánh",
  DISHWASHER: "Rửa chén bát",
  CASHIER: "Thu ngân",
  RECEPTIONIST: "Lễ tân / Order",
  DELIVERY: "Giao hàng nội bộ",
  SECURITY: "Bảo vệ",
  PARKING: "Trông xe",
  CLEANER: "Tạp vụ vệ sinh",
  STOCK_KEEPER: "Thủ kho",
  MANAGER: "Quản lý",
  SHIFT_LEADER: "Trưởng ca",
  SUPERVISOR: "Giám sát",
  TRAINER: "Đào tạo",
  MARKETING: "Marketing / Truyền thông",
  OTHER: "Khác",
};
